<template>
    <div>
      <div class="mb-5">
        <div class="headline saPrimary--text"> {{ $t("widgets.title") }}</div>
        <span class="body-1 greyDarken3--text">{{ $t("widgets.list.subtitle") }}</span>
      </div>
      <v-card>
        <!-- Create new Widget -->
          <v-card-title >
            <v-spacer></v-spacer>
            <CreateWidget />
          </v-card-title>
        <!-- Create new Widget -->
        <v-card-title>
          <div v-if="total" class="title"><span>Total : </span><b>{{ total }}</b></div>
          <v-spacer></v-spacer>
          <v-text-field
            class="custom-placeholer-color"
            append-outer-icon="search"
            v-model="search"
            label="Search"
            :placeholder="'Search by id, name or content'"
            clear-inner-icon="rms_close"
            clearable
            single-line
            hide-details
            @keyup.enter="getAllWidgetsFromApi"
            @click:clear="clearSearch"
            @click:append-outer="applySearch"
            color="saSecondary"
          ></v-text-field>
        </v-card-title>
        <v-data-table
          v-if="widgets"
          :headers="table_headers"
          :items="widgets"
          :loading="loading"
          :pagination.sync="pagination"
          :total-items="total"
          :rowsPerPageItems="rowsPerPageItems"
          item-key="id"
        >
            <template v-slot:items="props">
                <tr class="cursor-pointer" @click="viewWidget(props.item.id)">
                  <td width="6%">{{ props.item.id }}</td>
                  <td>
                    <span>{{ props.item.name.en }}</span>
                  </td>
                  <td>{{ DEFINES.WIDGETS.TYPES[props.item.type] }}</td>
                  <td>{{ props.item.screener_ids?props.item.screener_ids.length:0 }}</td>
                  <td>
                    <v-chip :class="props.item.published?'success success--text':'grey grey--text'" small outline>
                      <b>{{ DEFINES.SCREENER_STATUS[props.item.published]}}</b>
                    </v-chip>
                  </td>
                  <td >
                    {{ moment(props.item.created_at).format("DD MMM YYYY, HH:MM") }}
                  </td>
                </tr>
            </template>
        </v-data-table>
        </v-card>
    </div>
</template>

<script>
import i18n from "@/i18n";
import { mapGetters } from "vuex";
import { mapFields } from "vuex-map-fields";
import rules from "@/validation";
import CreateWidget from './Create.vue'

export default {
  name: "AdminWidgetList",
  async beforeRouteEnter(to, from, next) {
    await next((vm) => {
      vm.getAllWidgetsFromApi();
    });
  },
  components:{
    CreateWidget
  },
  data(){
    return {
      rules,
      table_headers: [
        {
          text: i18n.t("mew.table.header.widget_id"),
          sortable: true,
          align: "left",
          value: "id",
        },
        {
          text: i18n.t("rms.table.header.name"),
          sortable: true,
          align: "left",
          value: "name",
        },
        {
          text: i18n.t("rms.table.header.type"),
          sortable: true,
          align: "left",
          value: "type",
        },
        {
          text: i18n.t("mew.table.header.event_count"),
          sortable: false,
          align: "left",
          value: "screener_ids",
        },
        {
          text: i18n.t("rms.table.header.status"),
          sortable: true,
          align: "left",
          value: "published",
        },
        {
          text: i18n.t("rms.table.header.created_on"),
          align: "left",
          sortable: true,
          value: "created_at",
        }
      ],
      search: "",
      confirmation: false,
      loading: false,
      rowsPerPageItems: [5, 10, 25, 50, 100],
      pagination: {
        sortBy: "created_at",
        descending: true,
        rowsPerPage: 10,
        page: 1,
      },
      total: 0,
      selected: []
    }
  },
  computed: {
    ...mapGetters({
      isSuperAdmin: "user/isSuperAdmin",
    }),
    ...mapGetters("adminWidget", {
      widgets: "list",
    }),
  },
  watch: {
    pagination: {
      handler() {
        this.getAllWidgetsFromApi();
      },
      deep: true,
    },
  },
  methods:{
    applySearch() {
      if (this.search.length) this.getAllWidgetsFromApi();
    },
    clearSearch() {
      this.search = null;
      this.getAllWidgetsFromApi();
    },
    async getAllWidgetsFromApi() {
      this.loading = true;
      const { sortBy, descending, page, rowsPerPage } = this.pagination;
      var offset = this.getPaginationOffset(rowsPerPage, page);

      // Payload
      let payload = {
        offset: offset,
        limit: rowsPerPage,
        sort: sortBy,
        sorting_order: descending,
        search: this.search,
      };

      try {
        var result = await this.$store.dispatch("adminWidget/list", payload);
        this.total = result.widgets.total;
      } catch (error) {
        this.$store.dispatch("app/showMessage", {
          message: error.message,
          color: this.DEFINES.SNACKBAR_ERROR_COLOR,
        });
      }
      this.loading = false;
    },
    getPaginationOffset: (recordPerPage, page) => recordPerPage * (page - 1),
    viewWidget(widget_id) {
      this.$router.push({
        name: "AdminWidgetRoot",
        params: {
          widget_id: widget_id
        },
      });
    },
  }
}
</script>

